import Stage from "@frog/source/models/Stage.js"
import Delta from "@frog/source/models/Delta.js"
import isString from "@frog/source/utility/isString.js"

export default class Step {
    static instantiate(step) {
        if(step.alphastage == undefined) {
            throw new Error("Needs alphastage")
        }

        step.deltastages = step.deltastages || []

        if(step.deltastage != undefined) {
            if(step.deltastage instanceof Array) {
                step.deltastages = step.deltastage
            } else {
                step.deltastages = [
                    step.deltastage
                ]
            }
        }

        step.omegastage = Stage.copy(step.alphastage)
        step.deltastages.forEach((deltastage) => {
            step.omegastage = Delta.editStage(step.omegastage, deltastage)
        })

        // step.func is also supported! it'll be executed when it pops up in the queue.
        step.func = step.func || undefined

        // step.type is also supported! it'll tell which animation to use to run the deltastages.
        step.type = step.type || undefined

        return step
    }
    static add(step, deltastages) {
        if(deltastages == undefined) {
            return
        }
        if(deltastages instanceof Array) {
            deltastages.forEach((deltastage) => {
                step.deltastages.push(deltastage)
                step.omegastage = Delta.editStage(step.omegastage, deltastage)
            })
        } else {
            const deltastage = deltastages
            step.deltastages.push(deltastage)
            step.omegastage = Delta.editStage(step.omegastage, deltastage)
        }
    }
    static copy(step) {
        if(step == undefined) return undefined
        if(step instanceof Function) return step
        if(isString(step)) return step
        return {
            "func": step.func,
            "type": step.type,
            "name": step.name,
            "alphastage": step.alphastage,
            "deltastages": step.deltastages,
            "omegastage": step.omegastage,
            "stage": step.stage,

            "savestateSlug": step.savestateSlug,

            "followingProtosteps": step.followingProtosteps,
            "isUnskippable": step.isUnskippable,
            "isIgnorable": step.isIgnorable,
            "duration": step.duration,
            "path": step.path,
            "data": step.data,
        }
    }

    // TODO: move into PlotSteps as a convenience function
    static deltastage(deltastages, duration) {
        if(deltastages instanceof Array == false) {
            deltastages = [deltastages]
        }
        return {
            "duration": duration,
            "deltastages": deltastages
        }
    }
    static deltaflag(key, value) {
        return {
            "flag": {key, value}
        }
    }
    static flag(key, value) {
        return {
            "deltastages": [
                {
                    "flag": {key, value}
                }
            ]
        }
    }
}

// steps are instantiated in:
// - unit.calculateAction (move/turn/die/exhaust)
// - skills.getStep
// - reactions
// - chapter events
// - where else?
// different parts:
// - action/turn has steps
//   - steps aka events aka beats. has deltastages. LOTS of them. 1 deltastage 1 pr operty.
// 	    - delta stage is misnomer for just 1 property.
